import { useStep } from "../Form";
import React from "react";
export default function SubForm({steps}){
    const { currentStep } = useStep(); // Extract the current step from context
  
    // Return the component of the current step
    const StepComponent = steps[currentStep]?.component;
  
    return StepComponent ? <StepComponent /> : <p>No component available for this step.</p>;
  }